/** @jsx jsx */
import { useState, Fragment, useEffect } from 'react'
import { css, jsx } from '@emotion/core'
import { Input, NumericInput } from '@livechat/design-system'

const answerCss = css`
  .edit-range {
    display: flex;
    align-items: center;
    margin: 5px 0;

    .lc-input {
      margin-left: 5px;
      width: 255px;
    }
  }

  .answer-check {
    margin-right: 8px;

    > img {
      width: 16px;
    }
  }

  .answer-drop {
    > img {
      width: 16px;
    }
  }

  .single-error {
    margin-left: 67px;
  }
`

const Score = ({ update, submitted, index }) => {
  const [range, setRange] = useState({ min: 1, max: 10 })
  const [labels, setLabels] = useState({ min: '', max: '' })

  useEffect(() => {
    update('score', { range, labels })
  }, [range, labels])

  const getRangesErrors = () => {
    const errors = {
      min: undefined,
      max: undefined,
    }
    if (submitted) {
      if (!range.min) {
        errors.min = true
      }
      if (!range.max) {
        errors.max = true
      }

      console.log(typeof range?.min)

      if (isNaN(range?.min)) {
        errors.min = true
      }

      if (isNaN(range?.max)) {
        errors.max = true
      }
    }

    return errors
  }

  const rangeErrors = getRangesErrors()

  const getLabelsErrors = () => {
    const errors = {
      min: undefined,
      max: undefined,
    }
    if (submitted) {
      if (!labels.min) {
        errors.min = 'Label cannot be empty.'
      }
      if (!labels.max) {
        errors.max = 'Label cannot be empty.'
      }
    }

    return errors
  }

  const labelsErrors = getLabelsErrors()

  const labelsAreEqual = labels.min && labels.max && labels.min === labels.max

  return (
    <Fragment>
      <div css={answerCss}>
        <div className="edit-range">
          <NumericInput
            width="60px"
            min={0}
            max={1}
            value={range.min}
            onChange={(value) => setRange({ ...range, min: value })}
            error={rangeErrors.min}
            data-cy={`field-${index}-score-numeric-input-min`}
          />
          <Input
            value={labels.min}
            error={labelsErrors.min || labelsAreEqual}
            onChange={(event) =>
              setLabels({ ...labels, min: event.target.value })
            }
            placeholder="Label for min"
            data-cy={`field-${index}-score-input-min`}
          />
        </div>
        {labelsErrors.min && (
          <span className="error single-error" style={{ marginBottom: '5px' }}>
            Label cannot be empty
          </span>
        )}
        <div className="edit-range">
          <NumericInput
            width="60px"
            min={2}
            max={10}
            value={range.max}
            onChange={(value) => setRange({ ...range, max: value })}
            error={rangeErrors.max}
            data-cy={`field-${index}-score-numeric-input-max`}
          />
          <Input
            value={labels.max}
            error={labelsErrors.max || labelsAreEqual}
            onChange={(event) =>
              setLabels({ ...labels, max: event.target.value })
            }
            placeholder="Label for max"
            data-cy={`field-${index}-score-input-max`}
          />
        </div>
        {labelsErrors.max && (
          <span className="error single-error" style={{ marginBottom: '5px' }}>
            Label cannot be empty
          </span>
        )}
      </div>
      {labelsAreEqual && (
        <span
          className="error"
          style={{ marginBottom: '5px', marginLeft: '66px' }}
        >
          Labels cannot be equal
        </span>
      )}
    </Fragment>
  )
}

export default Score
